import styled from 'styled-components'

export const BankSettingsWrapper = styled.div`
  padding-top: 10px;
  font-family: ${({ theme }) => theme.fontFamily.inter};
  font-style: normal;
  font-weight: normal;

  .account_num_input {
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }

  .bank-form {
    /* margin-top: 40px; */

    .blur {
      background-color: #6e7191;
      pointer-events: none;
    }
  }

  p {
    font-size: ${({ theme }) => theme.fontSize.s};
    line-height: 24px;
    letter-spacing: 0.75px;
    color: ${({ theme }) => theme.colors.gray};
    opacity: 0.8;
    margin-top: -15px;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      margin-top: -10px;
    }
  }

  .bank-inputs-container {
    margin-bottom: 20px;
    position: relative;

    .error-container {
      padding-top: 15px;

      p {
        color: red;
      }
    }
  }

  /* .bank-inputs-container.name {
    margin-top: 60px;
  } */
  .wallet {
    color: ${({ theme }) => theme.colors.navyBlue};
    font-family: ${({ theme }) => theme.fontFamily.inter};
    font-size: ${({ theme }) => theme.fontSize.xl};
  }

  .input-title {
    font-size: ${({ theme }) => theme.fontSize.x2};
    line-height: 4px;
    color: ${({ theme }) => theme.colors.NeutralBlack};
    opacity: 0.8;
    font-weight: 400;
    margin: 0;
    padding-bottom: 15px;
  }

  .line {
    height: 3px;
    width: auto;
    background: ${({ theme }) => theme.colors.grey};
    margin: 0px -47px;
  }
  .cancel {
    background-color: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.CollaboBlue};
    border: 1px solid ${({ theme }) => theme.colors.CollaboBlue};
  }
  .confirm {
    margin: 10px 0px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .note {
    margin-top: 15px;
  }
  .choose {
    font-size: ${({ theme }) => theme.fontSize.x4};
    line-height: 14px;
    color: ${({ theme }) => theme.colors.dark};
    margin-top: 40px;
  }
  input,
  .color {
    color: ${({ theme }) => theme.colors.CollaboBlue};
  }

  .top {
    position: relative;
    margin-top: 5rem;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      margin-top: 7rem;
    }
  }
`

export const BankAccountsWrapper = styled.div`
  font-family: ${({ theme }) => theme.fontFamily.inter};
  font-style: normal;
  font-weight: normal;

  .title {
    color: ${({ theme }) => theme.colors.navyBlue};
    font-family: ${({ theme }) => theme.fontFamily.inter};
    font-size: ${({ theme }) => theme.fontSize.xl};
  }

  .bank_list_wrapper {
    height: 430px;
    margin-top: 3rem;
    /* margin: 20px 0; */
  }

  .btn-container {
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      margin-top: 3rem;
    }
  }

  .bank_delete_link {
    text-decoration: none;
    color: ${({ theme }) => theme.colors.dark};
  }

  .bank_account_details {
    display: flex;
    align-items: center;
    width: 90%;
    /* justify-content: space-between; */
    margin-bottom: 15px;
    background: #ffffff;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.03);
    border-radius: 4px;
    padding: 10px 15px 10px 10px;
    position: relative;
  }

  .bank_name_account {
    margin-left: 20px;
  }

  .account_num {
    margin: 0;
    font-style: normal;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.navyBlue};
    padding-bottom: 7px;
  }

  .account_name {
    font-style: normal;
    font-weight: 400;
    font-size: ${({ theme }) => theme.fontSize.x4};
    text-transform: capitalize;
    margin: 0;
    color: ${({ theme }) => theme.colors.contestPrimary};
  }

  .bank_logo img {
    height: 48px;
    width: 48px;
    object-fit: cover;
    border: 1px solid #f2f2f2;
    border-radius: 6px;
    object-position: center;
  }

  .card_arrow {
    position: absolute;
    top: 25px;
    right: 20px;
  }
  .vault_container {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 5rem;
    flex-direction: column;
  }
`

export const BankDeleteStyle = styled.div`
  /* padding: 10px; */
  margin: 80px 30px;

  .bank_delete_text {
    font-weight: 600;
  }

  .account_name_text {
    text-transform: capitalize;

    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      margin-left: 5.5rem;
    }
  }

  .img-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      height: 70px;
      width: 70px;
      object-fit: cover;
      object-position: center;
    }
  }

  .account_details_wrapper {
    display: flex;
    justify-content: space-between;
  }

  .delete_bank_action {
    text-align: center;
    color: red;

    p {
      cursor: pointer;
    }
  }

  .no_bank_container {
    height: 100vh;
    padding-top: 90px;
    display: flex;
    justify-content: center;
  }

  .vault_container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 100vh;
  }
`
